import React from "react";

import { CreationFooter } from "components/organisms/CreationModal";

import { FOOTER_ACTION_DESTINATION_TYPES } from "../../DestinationCreation.constants";

/**
 * Footer for the configure step.
 *
 * Types in `FOOTER_ACTION_DESTINATION_TYPES` render the action their form
 * registered (`footerAction`). While nothing is registered (the OAuth connect
 * button in the content is the only action) only Back and Cancel are shown.
 * Every other type keeps the host Create destination button.
 */
const DestinationFormFooter = ({
    language,
    destinationCode,
    footerAction,
    onBack,
    onCancel,
    onSubmit,
    isSubmitDisabled = false,
    isSubmitLoading = false,
    submitButtonRef,
}) => {
    const backLabel = language?.buttons?.back ?? "Back";
    const cancelLabel = language?.buttons?.cancel ?? "Cancel";
    const usesFooterAction =
        FOOTER_ACTION_DESTINATION_TYPES.includes(destinationCode);

    if (usesFooterAction && !footerAction) {
        return (
            <CreationFooter
                onBack={onBack}
                backLabel={backLabel}
                onCancel={onCancel}
                cancelLabel={cancelLabel}
                hideSubmit
            />
        );
    }

    if (usesFooterAction && footerAction) {
        return (
            <CreationFooter
                ref={submitButtonRef}
                onBack={onBack}
                backLabel={backLabel}
                onCancel={onCancel}
                cancelLabel={cancelLabel}
                onSubmit={footerAction.onSubmit}
                submitLabel={footerAction.label}
                isSubmitDisabled={footerAction.isDisabled}
                isSubmitLoading={footerAction.isLoading || isSubmitLoading}
                submitTestId="create-destination-submit"
            />
        );
    }

    return (
        <CreationFooter
            ref={submitButtonRef}
            onBack={onBack}
            backLabel={backLabel}
            onCancel={onCancel}
            cancelLabel={cancelLabel}
            onSubmit={onSubmit}
            submitLabel={"Create destination"}
            isSubmitDisabled={isSubmitDisabled}
            isSubmitLoading={isSubmitLoading}
            submitTestId="create-destination-submit"
        />
    );
};

export default DestinationFormFooter;
